// import React, { useState, useEffect } from "react";
// import { ArrowLeft, Search } from "lucide-react";
// import { Link } from "react-router-dom";
// import Navbar from "../components/Navbar";
// import ActsCard from "../components/actsCard";
// import Footer from "../components/Footer";
// import { db } from "../firebase"; // Ensure you have configured Firebase
// import { collection, getDocs } from "firebase/firestore";
// import LoadingSpinner from "../components/LoadingSpinner";

// const BareAct = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [fetching, setFetching] = useState(false);
//   const [acts, setActs] = useState([]);

// //oldurl=https://bareacts.onrender.com/api/bareacts
//   useEffect(() => {
//     const fetchActs = async () => {
//       try {

//         setFetching(true)
//         const resp = await fetch("https://bareact-backend-596718606544.us-central1.run.app/bareacts");
//         console.log(resp)
//         const respJson = await resp.json()
//         console.log(respJson.bareActs)
//         setActs(respJson.bareActs)
//         setFetching(false);
//       } catch (error) {
//         console.log(error);
//         setFetching(false)
//       }
//     }

//     fetchActs()
//   }, [])

//   const filteredActs = acts.filter(
//     (act) =>
//       act.title.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <>
//       <div className="relative min-h-screen flex flex-col">
//         <Navbar />
//         <div className="background-circle circle-3 z-0"></div>
//         <div className="background-circle circle-4 z-0"></div>
//         <div className="relative z-10 grid grid-cols-2 items-center pt-4 pb-4 px-6">
//           {/* Page Title */}
//           <div className="flex items-center mb-6">
//             <Link to="/portal/Dashboard">
//               <div className="flex items-center md:ml-12">
//                 <ArrowLeft style={{ color: "white" }} />
//                 <h1 className="text-yellow-500 ml-4 font-bold text-2xl">
//                   Bare Act
//                 </h1>
//               </div>
//             </Link>
//           </div>
//           <div className="flex items-center justify-end space-x-4 mr-8 relative">
//             <input
//               type="text"
//               name="search"
//               placeholder="search"
//               className="border-b border-white bg-transparent p-2 outline-none text-white"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//             <Search className="text-white absolute top-1/2 right-3 transform -translate-y-1/2" />
//           </div>
//         </div>
//         <main className="pl-0.5 pr-0.5 md:px-16 py-0.5">
//           {fetching ? <LoadingSpinner /> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ml-20 mr-20 mt-5 relative z-10 mb-12">
//             {filteredActs.map((item) => (
//               <ActsCard key={item.id} name={item.title} pdfUrl={item.url} />
//             ))}
//           </div>}

//         </main>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default BareAct;


































import React, { useState, useEffect } from "react";
import { ArrowLeft, Search } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LoadingSpinner from "../components/LoadingSpinner";

const BareAct = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [fetching, setFetching] = useState(false);
  const [acts, setActs] = useState([]);

  useEffect(() => {
    const fetchActs = async () => {
      try {
        setFetching(true);
        const resp = await fetch(
          "https://bareact-backend-596718606544.us-central1.run.app/bareacts"
        );
        const respJson = await resp.json();
        setActs(respJson.bareActs);
        setFetching(false);
      } catch (error) {
        console.log(error);
        setFetching(false);
      }
    };

    fetchActs();
  }, []);

  const filteredActs = acts.filter((act) =>
    act.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className="relative min-h-screen flex flex-col overflow-hidden">
        <Navbar />

        {/* Background */}
        <div className="background-circle circle-3 z-0"></div>
        <div className="background-circle circle-4 z-0"></div>

        {/* HEADER */}
        <div className="relative z-10 flex flex-col md:flex-row justify-between items-center px-6 md:px-16 pt-6">

          {/* BACK */}
          <Link to="/portal/Dashboard">
            <div className="light-gold-text flex items-center group cursor-pointer mb-6 md:mb-0">
              <ArrowLeft className="bare-arrow text-white transition-transform duration-300 group-hover:-translate-x-1" />
              <h1 className=" text-yellow-500 ml-4 font-bold text-2xl tracking-wide">
                Bare Act
              </h1>
            </div>
          </Link>

          {/* 🔥 SEARCH BAR */}
    <div className="
  bareact-search
  relative w-full md:w-[300px]
  md:mr-14
  backdrop-blur-xl
  bg-white/10
  border border-white/20
  rounded-full
  px-6 py-2
  flex items-center
  transition-all duration-300
  hover:shadow-[0_5px_20px_rgba(255,255,255,0.2)]
">
            <Search className="text-gray-300 mr-2" />
            <input
              type="text"
              placeholder="Search Bare Acts..."
              className="bg-transparent outline-none text-white w-full placeholder-gray-400"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* TITLE */}
        <h2 className="bare-title text-center text-white text-3xl md:text-4xl font-semibold mt-8 mb-10 tracking-wide relative z-10">
          Browse Legal Acts
        </h2>

        {/* MAIN */}
        <main className="px-4 md:px-16 flex-grow">

          {fetching ? (
            <div className="flex justify-center items-center mt-20">
              <LoadingSpinner />
            </div>
          ) : (
            <div className="
              grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4
              gap-8
              mb-16
              relative z-10
            ">
              {filteredActs.map((item) => (
                
                <div key={item.id} className="group relative">

                  {/* 🔥 Glow Border */}
                  <div className="
                    absolute -inset-[1px]
                    rounded-2xl
                    bg-gradient-to-r from-white/20 via-transparent to-white/20
                    opacity-0 group-hover:opacity-100
                    blur-sm
                    transition duration-500
                  "></div>

                  {/* 🔥 CARD */}

                  <div
                    onClick={() => {
                    const encodedUrl = encodeURIComponent(item.url);
                    navigate(`/portal/actPage/${encodedUrl}`);
                  }}
                  className="
                    bareact-card
                    relative z-10 block
                    bg-gradient-to-br from-[#1f2937]/90 via-[#243447]/80 to-[#1e293b]/90
                    backdrop-blur-xl
                    border border-white/10
                    rounded-2xl
                    p-6
                    h-full
                    flex items-center justify-center text-center
                    transition-all duration-500
                    group-hover:scale-105
                    group-hover:-translate-y-2
                    group-hover:shadow-[0_20px_60px_rgba(0,0,0,0.5)]
                    cursor-pointer
                  "
                >
                  <p className="bareact-card-title text-white font-medium text-lg leading-relaxed">
                    {item.title}
                  </p>
                </div>

                </div>

              ))}
            </div>
          )}
        </main>
      </div>

      <Footer />
    </>
  );
};

export default BareAct;
